<sabis-ngx-button color="primary" [disabled]="isSaving || isLoading" (click)="onAddClick()">
  Add
</sabis-ngx-button>

<sabis-ngx-button color="primary" [disabled]="isSaving || isLoading" (click)="onSaveClick()">
  Save
</sabis-ngx-button>

<sabis-grid2 #grid
             [scColumns]="columns"
             [scDataLoader]="dataLoader"
             (scOnDataChanged)="onDataChanged($event)"></sabis-grid2>
